module.exports = {
  title: 'MedReading',
  baseUrl: process.env.VUE_APP_BASE_URL,
  imageUrlPrefix: process.env.VUE_APP_BASE_FILE
}
